import { createApiActions } from '@shared/ngrx-factory/factory.actions';
import { CompanyResponse } from '@modules/company-profile/store/company-profile.action';
import { PageableParamInput } from '@modules/external-services/company-management/requests/pageable-param.search';
import {
  FinancialSecurityTypeDtoInput,
  SaveFinancialSecurityTypeRequest,
} from '../requests/save-security-type.request';
import { SaveFinancialSecurityRuleRequest } from '../requests/create-security-rules.request';
import { BankConfigRequest } from '../requests/bank-config.request';
import { SaveFobReferenceRequest } from '../requests/save-fob-reference.request';
import { SaveCoverageFormulaRequest } from '../requests/save-coverage-formula.request';
import { SaveBankGuaranteeTypeRequest } from '../requests/bank-gurantee-type.request';

//TYPES
export const FinancialSecurityTypesAction = createApiActions<PageableParamInput, CompanyResponse>(
  'Financial Security Types',
  'Fetch Types',
);

export const FinancialSecuritySubmitTypesAction = createApiActions<
  SaveFinancialSecurityTypeRequest,
  CompanyResponse
>('Financial Security Types', 'Submit Types');

export const FinancialSecurityTypesUpdateAction = createApiActions<
  SaveFinancialSecurityTypeRequest,
  CompanyResponse
>('Financial Security Types', 'Update Types');

export const FinancialSecurityTypesDeleteAction = createApiActions<string, CompanyResponse>(
  'Financial Security Types',
  'Delete Types',
);

//RULES
export const FinancialSecurityRulesAction = createApiActions<PageableParamInput, CompanyResponse>(
  'Financial Security Rules',
  'Fetch Rules',
);

export const FinancialSecuritySubmitRulesAction = createApiActions<
  SaveFinancialSecurityRuleRequest,
  CompanyResponse
>('Financial Security Rules', 'Submit Rules');

export const FinancialSecurityRulesUpdateAction = createApiActions<
  SaveFinancialSecurityRuleRequest,
  CompanyResponse
>('Financial Security Rules', 'Update Rules');

export const FinancialSecurityRulesDeleteAction = createApiActions<string, CompanyResponse>(
  'Financial Security Rules',
  'Delete Rules',
);

export const FinancialSecurityRulesActivateAction = createApiActions<string, CompanyResponse>(
  'Financial Security Rules',
  'Activate Rule',
);

export const FinancialSecurityRulesDeactivateAction = createApiActions<string, CompanyResponse>(
  'Financial Security Rules',
  'Deactivate Rule',
);

// CURRENCIES
export const FinancialSecurityCurrenciesAction = createApiActions<
  PageableParamInput,
  CompanyResponse
>('Financial Security Currencies', 'Fetch Currencies');

// Banking Configuration
export const FinancialSecurityBankingIntegrationsAction = createApiActions<
  PageableParamInput,
  CompanyResponse
>('Financial Security Banking Configuration', 'Fetch Banking Configuration');

export const FinancialSecurityBankingIntegrationsSubmitAction = createApiActions<
  BankConfigRequest,
  CompanyResponse
>('Financial Security Banking Configuration', 'Submit Banking Configuration');

export const FinancialSecurityBankingIntegrationsUpdateAction = createApiActions<
  BankConfigRequest,
  CompanyResponse
>('Financial Security Banking Configuration', 'Update Banking Configuration');

export const FinancialSecurityBankingIntegrationsDeleteAction = createApiActions<
  string,
  CompanyResponse
>('Financial Security Banking Configuration', 'Delete Banking Configuration');

// COUNTRIES
export const FinancialSecurityCountriesAction = createApiActions<
  PageableParamInput,
  CompanyResponse
>('Financial Security Countries', 'Fetch Countries');

// FOB REFERENCES
export const FinancialSecurityFobReferencesAction = createApiActions<
  PageableParamInput,
  CompanyResponse
>('Financial Security FOB References', 'Fetch FOB References');

export const FinancialSecuritySubmitFobReferencesAction = createApiActions<
  SaveFobReferenceRequest,
  CompanyResponse
>('Financial Security FOB References', 'Submit FOB References');

export const FinancialSecurityFobReferencesUpdateAction = createApiActions<
  SaveFobReferenceRequest,
  CompanyResponse
>('Financial Security FOB References', 'Update FOB References');

export const FinancialSecurityFobReferencesDeleteAction = createApiActions<
  string,
  CompanyResponse
>('Financial Security FOB References', 'Delete FOB References');

// COVERAGE FORMULAS
export const FinancialSecurityCoverageFormulaAction = createApiActions<
  PageableParamInput,
  CompanyResponse
>('Financial Security Coverage Formula', 'Fetch Coverage Formulas');

export const FinancialSecuritySubmitCoverageFormulaAction = createApiActions<
  SaveCoverageFormulaRequest,
  CompanyResponse
>('Financial Security Coverage Formula', 'Submit Coverage Formula');

export const FinancialSecurityCoverageFormulaUpdateAction = createApiActions<
  SaveCoverageFormulaRequest,
  CompanyResponse
>('Financial Security Coverage Formula', 'Update Coverage Formula');

export const FinancialSecurityCoverageFormulaDeleteAction = createApiActions<
  string,
  CompanyResponse
>('Financial Security Coverage Formula', 'Delete Coverage Formula');

export const FinancialSecurityCoverageFormulaActivateAction = createApiActions<
  string,
  CompanyResponse
>('Financial Security Coverage Formula', 'Activate Coverage Formula');

// PEGGED COST CATEGORIES
export const FinancialSecurityPeggedCostCategoriesAction = createApiActions<
  PageableParamInput,
  CompanyResponse
>('Financial Security Pegged Cost Categories', 'Fetch Pegged Cost Categories');

export const FinancialSecurityPeggedCostCategorySubmitAction = createApiActions<
  any,
  CompanyResponse
>('Financial Security Pegged Cost Categories', 'Submit Pegged Cost Category');

export const FinancialSecurityPeggedCostCategoryUpdateAction = createApiActions<
  any,
  CompanyResponse
>('Financial Security Pegged Cost Categories', 'Update Pegged Cost Category');

export const FinancialSecurityPeggedCostCategoryDeleteAction = createApiActions<
  string,
  CompanyResponse
>('Financial Security Pegged Cost Categories', 'Delete Pegged Cost Category');

// BANK GUARANTEE TYPES
export const FinancialSecurityBankGuaranteeTypesAction = createApiActions<
  PageableParamInput,
  CompanyResponse
>('Financial Security Bank Guarantee Types', 'Fetch Bank Guarantee Types');

export const FinancialSecurityBankGuaranteeTypeSubmitAction = createApiActions<
  SaveBankGuaranteeTypeRequest,
  CompanyResponse
>('Financial Security Bank Guarantee Types', 'Submit Bank Guarantee Type');

export const FinancialSecurityBankGuaranteeTypeUpdateAction = createApiActions<
  SaveBankGuaranteeTypeRequest,
  CompanyResponse
>('Financial Security Bank Guarantee Types', 'Update Bank Guarantee Type');

export const FinancialSecurityBankGuaranteeTypeDeleteAction = createApiActions<
  string,
  CompanyResponse
>('Financial Security Bank Guarantee Types', 'Delete Bank Guarantee Type');
